import { Tool } from './base'

export class TaniumSignalTool extends Tool {
  public readonly toolName = 'Tanium Signal'
  public readonly toolKind = 'edr' as const

  // public generateSearchPermalink(
  //   rootURL: string,
  //   renderedContent: string
  // ): string {
  //   const encodedRenderedContent = encodeURIComponent(renderedContent);
  //   return `${rootURL}`;
  // }
}
